import React from "react";
import { UserProfile } from "./profile";
import { MainSection } from "./main";
import { DraggableScrollContainer } from "../../atom/DraggableScrollContainer";
import { GdprClauseModal } from "../../atom/GdprClauseModal";

export const Dashboard = () => {
  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex flex-1 overflow-hidden w-full gap-[20px]">
        <DraggableScrollContainer className="w-[852px] overflow-y-auto select-none pt-5 pl-2 mb-[20px]">
          <MainSection />
        </DraggableScrollContainer>
        <DraggableScrollContainer className="flex-1 overflow-y-auto w-full select-none pt-5 pr-[20px]">
          <div>
            <UserProfile />
          </div>
        </DraggableScrollContainer>
      </div>

      <GdprClauseModal />
    </div>
  );
};
